import * as React from 'react'
import { Breadcrumbs } from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import { getActiveBreadcrumb } from '../utilities'
import { STEPS } from './types'

export const BREADCRUMBS = [
  'Customer',
  "Customer's item",
  'Work description',
  'Schedule',
]

interface StepBreadcrumbProps {
  step: STEPS
}

export const StepBreadcrumbs: React.FC<StepBreadcrumbProps> = ({ step }) => {
  const breadcrumbs = BREADCRUMBS

  const t = useT()
  const breadcrumbsContext = 'Breadcrumb text in service modal'
  const breadcrumbsMapping = breadcrumbs.map(breadcrumb => {
    return t(breadcrumb, {
      _context: breadcrumbsContext,
    })
  })

  const activeBreadcrumb = getActiveBreadcrumb({
    step,
    breadcrumbs,
  })

  return (
    <Breadcrumbs
      breadcrumbs={breadcrumbsMapping}
      activeBreadcrumb={activeBreadcrumb}
    />
  )
}
